
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affirm",
      function () {
        return require("private-next-pages/affirm/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affirm"])
      });
    }
  